import store, { actions } from "../../redux";
import { PostAnalysisProps } from "../../redux/slices/postAnalysis/PostAnalysis";
import { API_INSTANCES } from "../api_instance";
import { handleError } from "../errors";

const dispatch = store.dispatch;

const getPostMetadata = (post_id: string) => {
  return API_INSTANCES.METADATA_POSTS.getPostMetadata(post_id)
    .then((response) => {
      const data = response.data as PostAnalysisProps.PostAnalysis;
      dispatch(actions.postAnalysis.setPostAnalysisList(data));
    })
    .catch((error) => handleError(error, "getPostMetadata"));
};

const updateCheckPassed = (payload: PostAnalysisProps.updateCheckPassed) => {
  return API_INSTANCES.METADATA_POSTS.updateCheckPassed(payload)
    .then((response) => {
      const data = response.data as PostAnalysisProps.PostAnalysis;
      dispatch(actions.postAnalysis.setPostAnalysisList(data));
      dispatch(actions.postAnalysis.setPostAnalysisModalOpen(false));
      dispatch(actions.postAnalysis.setActivePostId(""));
    })
    .catch((error) => handleError(error, "updateCheckPassed"));
};

export const METADATA_POSTS = {
  getPostMetadata,
  updateCheckPassed,
};
